module.exports = __webpack_public_path__ + "img/img6.f5deb4c0.jpg";